import { render, staticRenderFns } from "./form.vue?vue&type=template&id=a1b5ff34&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1b5ff34')) {
      api.createRecord('a1b5ff34', component.options)
    } else {
      api.reload('a1b5ff34', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=a1b5ff34&", function () {
      api.rerender('a1b5ff34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/form/src/form.vue"
export default component.exports